export const getInvoiceUrl = (route: string, invoiceId: string = '') => {
  return route.replace(':invoiceId', invoiceId);
};
